export default __webpack_public_path__ + "static/img-digital-strategies-b7f637c89875e829b9f9e5795ca3a952.png";